
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { msgReady } from 'api/investor'
export default {
components: {
Loading,
XHeader,
XButton,
Flexbox,
FlexboxItem
},
data () {
return {
loading: true,
text: '加载中',
title: '服务协议及隐私变更通知',
content: '',
noticeType: '1', // 0 按钮 1 按钮 2 按钮
readyForm: {
sysName: 'TTD_FUND_GJ',
userId: '',
ids: ''
},
au: '',
testContent: '{"au":"VS8rOW5LdmM2aVE2WFp3M1VtTHBiL0JsOUtHQzUzdk5NN3B4RlZKMTlvcDJKc2dtTitMT1BnQWhubHhGRnNnNQ\u003d\u003d","content":"1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","created":1528427440000,"id":38756,"introduction":"1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","title":"星期五公告2","userId":1757}'
}
},
created () {








},
mounted () {
setTimeout(() => {
this.$bridge.registerHandler('agreeNotice', (data) => {
console.log(data, 333)
this.agreeNotiec(data)
})
this.getAgreeInfo()
}, 1000)






this.init('getParamsJson', (res) => {
console.log(res, 222)
let data = JSON.parse(res)
this.noticeType = data.noticeType
this.readyForm.userId = data.userId
this.readyForm.ids = data.id
this.au = data.au
this.$refs.content.innerHTML = data.content
})
},
computed: {
},
methods: {
init (fun, callback) {
window.initValue = (options) => {
let res = window.injs[fun]()
callback(res)
}
},
getAgreeInfo () {
this.$bridge.callHandler('getOptionsJson', {message: '获取内容'}, (res) => {
console.log(res, 111)
let data = JSON.parse(res)
this.noticeType = data.noticeType
this.readyForm.userId = data.userId
this.readyForm.ids = data.id.toString()
this.au = data.au
this.$refs.content.innerHTML = data.content
})
},
agree () {
console.log(this.readyForm)
console.log({au: this.au})
if (this.readyForm.userId && this.readyForm.ids && this.au) {
msgReady(this.readyForm, this.au).then((res) => {
if (res.code === 0 || res.code === 1001) {
this.$bridge.callHandler('agreeNotice', {message: '已同意'}, (data) => {})
} else {
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
} else {
this.$vux.toast.show({type: 'warn', text: '消息内容不完整'})
}
},
notAgree () {
this.$bridge.callHandler('disAgreeNotice', {message: '不同意'}, (data) => {})
},
agreeNotiec (info) {
let data = JSON.parse(info)
if (data.userId && data.ids && data.au) {
msgReady({sysName: 'TTD_FUND_GJ', userId: data.userId, ids: data.ids}, this.au).then((res) => {
if (res.code === 0 || res.code === 1001) {
this.$bridge.callHandler('agreeNotice', {message: '已同意'}, (data) => {})
} else {
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
} else {
this.$vux.toast.show({type: 'warn', text: '消息内容不完整'})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/AgreeUpdate/index.vue